import React, {  useEffect } from 'react';
import MetaTitle from '../components/MetaTitle';
import Header from './Header';
import "../assete/css/Literaturereview.css";
import litrature_pic_1 from "../assete/Add on service/literature_review-min.png";
import literature_pic_2 from "../assete/Add on service/literature-review1.jpg";
import literature_pic_3 from "../assete/Add on service/eb-removebg-preview-min.png";
import Footer from './Footer';
import AOS from "aos";
import "aos/dist/aos.css";
import Scrolltop from './Scrolltop';
import literature_vdo from "../assete/bannerimage/banner 11.avif";
import Whatsapp from './Whatsapp';
const Literaturereview = () => {
    useEffect(() => {
        AOS.init({
            duration:600,
            delay:300
        });
      }, []);
     
  return (
   <>
      <MetaTitle title={"ADD-ON-Service | Literature Review | "} description="Find the best place to guide your research works at an affordable price. Visit Sea Sense Software Pvt. Ltd. for PhD guidance."
        keywords="PhD guidance in Marthandam |
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships |
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari |
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu |
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil |
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum |
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey |
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai |
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai |
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy |
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli |
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore |
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india |
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam |
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin |
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam |
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |"/>
   <Header/>
   <div className='literature_main_div'>
   
   <img src={literature_vdo} alt="" className='background_image'/>
    
        <div className="about_content">
    <h1>Literature Review</h1>
    </div>
   </div>
   <div className='new_design_padding'>
   <div className='literature_div'>
    <div className='literature_div_1' data-aos="fade-down" data-aos-duration="2000">
        <h2>Literature Review</h2>
        <p>To begin with, a Literature review is the initial stage of any research writing for a journal or thesis writing. It is the base of any research. For this purpose, it provides a total clear logical knowledge of the topic. Therefore, this is the initial work of any research. At the same time, it will be followed corresponding to your instructions. For this reason, your satisfaction is our first goal.</p>
        <p>It is an important element of your research and dissertation as 
            it is the stage in which you try to identify any learning gaps in your schooling and knowledge sources. At this level,
             you should read, understand and analyze several research articles previously published in your field of study. The study material for the literature review is mostly determined by your topic selection and your base paper.To complete a literature review portion in their dissertation that is interesting and compelling enough, most people refer to an average of 10 to 20 research publications.</p>
    </div>
    <div className='literature_add_pic'>
        <img src={litrature_pic_1} alt="" data-aos="zoom-in"data-aos-duration="2000"/>
    </div>
   </div>

   <div className='litert_back_div'>
    <h2 data-aos="fade-down"data-aos-duration="2000">Typically there are 5 types of literature reviews</h2>
    <div className='literature_back_div_2'>
        <div className='litert_back_div_1' data-aos="fade-down"data-aos-duration="2000">
            <p>Systematic literature reviews</p>
        </div>
        <div className='litert_back_div_1' data-aos="fade-down"data-aos-duration="2000">
            <p>Traditional literature reviews</p>
        </div>
        <div className='litert_back_div_1' data-aos="fade-down"data-aos-duration="2000">
            <p>Narrative literature reviews</p>
        </div>
        <div className='litert_back_div_1' data-aos="fade-down"data-aos-duration="2000">
            <p >Meta-synthesis</p>
        </div>
        <div className='litert_back_div_1' data-aos="fade-down"data-aos-duration="2000">
            <p>Meta-analysis</p>
        </div>
    </div>
    </div>

    <div className='literature_last_div'>
        <div className='litrature_last_pic'>
            <img src={literature_pic_2} alt="" data-aos="zoom-in"data-aos-duration="2000"/>
        </div>
        <div className='literature_last_div_1' data-aos="fade-down"data-aos-duration="2000">
            <p>The first trouble faced in the literature review step is locating a group of relevant and high-quality papers and articles to review. To find such interesting and relevant research papers, one has to research the internet extensively. At Sea Sense Softwares, we have a team of professionals who specialize in research writing. They know where to look for relevant literature for your study topic and how to find it.</p>
            <p>Second, writing a literature review with all the information needed in all of the appropriate places takes a lot of time and effort. At Sea Sense, we know what it takes to write a high-quality literature review that will serve as the backbone of your research and dissertation. As a result, you can be assured that the responsibility for your literature review is in capable hands.</p>
            <p>Literature review is the backbone of any research writing for Journals or Writing Services. For this reason, it provides a clear logical understanding of the topic.</p>
            <p>This is the first preliminary starting work of any research report writing. At the same time, it will be followed according to your instructions. For this reason, your satisfaction is our first goal.</p>
        </div>
    </div>

    <div className='literature_sub_div'>
       
        <div className='literature_sub_div_conts' data-aos="fade-down"data-aos-duration="2000">
            <h2>This step further leads to</h2>
            <p>Synopsis and abstract of research.</p>
            <p>Research Methodology, Scope and limitations.</p>
            <p>Problem identification and selection.</p>
            <p>Need and importance of the study.</p>
            <p>Need objectives, data collection and analysis.</p>
            <p>Identification of research gaps.</p>
        </div>
        <div className='literature_sub_pic_add'>
            <img src={literature_pic_3} alt="" data-aos="zoom-in"data-aos-duration="2000"/>
        </div>

    </div>
    </div>
    <Whatsapp/>
    <Scrolltop/>
    <Footer/>
   </>
  )
}

export default Literaturereview